(function () {
  'use strict';

  angular.module('sempraWebapp').factory('TrendEnum', trendEnumFactory);

  function trendEnumFactory () {
    return Object.freeze({
      RISING: 'RISING',
      STEADY: 'STEADY',
      FALLING: 'FALLING'
    });
  }
})();
